module.exports = __webpack_public_path__ + "img/img01.a3859e88.jpeg";